import React from 'react';
import {
  CloudCog,
  GitBranch,
  LayoutTemplate,
  ServerCog,
  Workflow,
} from 'lucide-react';
import { SectionWrapper } from '../../components';
import ListItem from '../../components/ListItem/ListItem';
import { SECTION } from '../../constants/sections';
import { Theme } from '../../constants/styles';

const Skills = () => {
  return (
    <SectionWrapper section={SECTION.skills} theme={Theme.Dark}>
      <div className="list">
        <ListItem
          Icon={LayoutTemplate}
          title="Front-End"
          description="HTML5, CSS3, JavaScript, React"
        />
        <ListItem
          Icon={ServerCog}
          title="Back-End"
          description="Java, Spring Framework, SQL"
        />
        <ListItem
          Icon={CloudCog}
          title="DevOps & Cloud"
          description="Jenkins, AWS"
        />
        <ListItem
          Icon={GitBranch}
          title="Version Control"
          description="Git, GitHub, Bitbucket"
        />
        <ListItem
          Icon={Workflow}
          title="Tools & Workflow"
          description="REST APIs, CI/CD, Agile, JIRA"
        />
      </div>
    </SectionWrapper>
  );
};

export default Skills;
